/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Altedebitorennummer1Inputs */



/**

* @param {_Field_Altedebitorennummer1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_altedebitorennummer1 = /** @type {((inputs?: _Field_Altedebitorennummer1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Altedebitorennummer1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Alte Debitorennummer")
});
export { _field_altedebitorennummer1 as "_field_alteDebitorennummer" }